/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  RevokeSignInsResult,
  RevokeSignInsResult$inboundSchema,
} from "../components/revokesigninsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type LogoutEverywhereSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type LogoutEverywhereRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type LogoutEverywhereResponse = {
  headers: { [k: string]: Array<string> };
  result: RevokeSignInsResult;
};

/** @internal */
export type LogoutEverywhereSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const LogoutEverywhereSecurity$outboundSchema: z.ZodMiniType<
  LogoutEverywhereSecurity$Outbound,
  LogoutEverywhereSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function logoutEverywhereSecurityToJSON(
  logoutEverywhereSecurity: LogoutEverywhereSecurity,
): string {
  return JSON.stringify(
    LogoutEverywhereSecurity$outboundSchema.parse(logoutEverywhereSecurity),
  );
}

/** @internal */
export type LogoutEverywhereRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const LogoutEverywhereRequest$outboundSchema: z.ZodMiniType<
  LogoutEverywhereRequest$Outbound,
  LogoutEverywhereRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function logoutEverywhereRequestToJSON(
  logoutEverywhereRequest: LogoutEverywhereRequest,
): string {
  return JSON.stringify(
    LogoutEverywhereRequest$outboundSchema.parse(logoutEverywhereRequest),
  );
}

/** @internal */
export const LogoutEverywhereResponse$inboundSchema: z.ZodMiniType<
  LogoutEverywhereResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
    Result: RevokeSignInsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
      "Result": "result",
    });
  }),
);

export function logoutEverywhereResponseFromJSON(
  jsonString: string,
): SafeParseResult<LogoutEverywhereResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LogoutEverywhereResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LogoutEverywhereResponse' from JSON`,
  );
}
